// The Pro-upgrade wizard entry path. Every "go Pro" CTA points here now that the
// new wizard is the default flow for all users (the pro-upgrade3 rollout flag
// has been retired).
export const PRO_UPGRADE_ENTRY_PATH = '/dashboard/pro-upgrade'
